import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Brand } from "@/components/Brand";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/app");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-[#FAFAF7]">
      <div className="hidden lg:flex flex-col justify-between p-12 dark-section relative overflow-hidden">
        <div className="absolute inset-0 dot-bg-dark opacity-50" />
        <div className="absolute top-1/3 left-1/4 w-96 h-96 rounded-full bg-[#002FA7]/30 blur-3xl" />
        <div className="relative">
          <Brand light />
        </div>
        <div className="relative">
          <div className="label-mono !text-white/50 mb-4">— Pipeline ops</div>
          <div className="font-display text-5xl font-black tracking-tighter leading-tight text-white">
            Prospect.<br />Personalise.<br />Send.
          </div>
          <p className="mt-6 text-white/70 max-w-sm">Modern revenue tooling for teams that ship.</p>
        </div>
        <div className="relative text-xs font-mono uppercase tracking-widest text-white/40">© 2026 LeadsB2B</div>
      </div>
      <div className="flex items-center justify-center p-6 lg:p-12">
        <form onSubmit={submit} className="w-full max-w-sm">
          <div className="lg:hidden mb-8"><Brand /></div>
          <div className="label-mono mb-3">— Sign in</div>
          <h1 className="font-display text-4xl font-black tracking-tighter mb-8">Welcome back.</h1>
          <div className="space-y-5">
            <div>
              <Label htmlFor="email" className="label-mono">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 h-11 rounded-lg border-[#EAEAE3] bg-white" data-testid="login-email" />
            </div>
            <div>
              <Label htmlFor="password" className="label-mono">Password</Label>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 h-11 rounded-lg border-[#EAEAE3] bg-white" data-testid="login-password" />
            </div>
            <Button type="submit" disabled={loading} className="w-full h-11 rounded-lg bg-[#0A0A0F] hover:bg-[#14141B] text-white font-medium" data-testid="login-submit">
              {loading ? "Signing in…" : "Sign in"}
            </Button>
          </div>
          <div className="mt-6 text-sm text-[#5C5C66]">
            New to LeadsB2B?{" "}
            <Link to="/signup" className="text-[#0A0A0F] font-medium underline underline-offset-4 hover:text-[#002FA7]" data-testid="login-to-signup">Create an account</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
